import { Colors } from "../constants/Colors";

export class HexColor {
  color: string = Colors.Black;
  alpha: number = 1;

  constructor(color: string, alpha: number) {
    this.color = color;
    this.alpha = alpha;
  }

  public static populateWithDefaultIfNeeded(
    hexColor?: HexColor,
    color?: string,
    alpha?: number
  ): HexColor {
    if (!hexColor) {
      return HexColor.Black;
    }

    if (!hexColor.color) {
      hexColor.color = !color ? Colors.Black : color;
    }

    if (hexColor.alpha < 0 || hexColor.alpha > 1) {
      if (alpha === null || alpha === undefined || alpha < 0) {
        hexColor.alpha = 0;
      } else if (alpha > 1) {
        hexColor.alpha = 1;
      } else {
        hexColor.alpha = alpha;
      }
    }

    return hexColor;
  }

  public static fromColor(color: string): HexColor {
    return new HexColor(color, 1);
  }

  public static readonly Black = new HexColor(Colors.Black, 1);
  public static readonly White = new HexColor(Colors.White, 1);
}
